<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center mt-2 mb-2">
        <v-col cols="9" class="">

        </v-col>
        <v-col cols="3" class="search-col text-right" >
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="settlements"
          :options.sync="options"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :footer-props="footerProps"
          :server-items-length="total"
          :items-per-page="30"
          :fixed-header="true"
          height="60vh"
          :loading="loading"
          show-select
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.is_enabled="{ item }">
          <v-simple-checkbox v-if="item.ref !='e71c2a15-4b33-11e4-ab6d-005056801329'" @click="toggleEnabled(item)" :value="item.is_enabled"></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'np-settlement-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import NPService from "@/api/NPService";

export default {
  name: 'SettlementIndex',
  components: {},
  data: () => ({
    overlay: false,
    search: '',
    settlements: [],
    options: {},
    loading: false,
    footerProps: {
      itemsPerPageText: 'Элементов" на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [30]
    },
    total: 0,
    headers: [
      {
        text: 'Название',
        value: 'name',
        sortable: true,
      },
      {
        text: 'Район',
        value: 'area',
        sortable: true,
      },
      {
        text: 'Область',
        value: 'region',
        sortable: true,
      },
      {
        text: 'Включен',
        value: 'is_enabled',
        sortable: false,
      },
      {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
    ],
  }),
  mounted() {
    NPService.settlementsList().then(response => {
      this.settlements = response.data.data
      this.total = response.data.total
    })
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.getDataFromApi()
      }, 700)
    }
  },
  methods: {
    toggleEnabled(item) {
      item.is_enabled = !item.is_enabled
      const id = item.id
      NPService.settlementToggleEnabled(id).then(response => {
        item.is_enabled = response.data.is_enabled
      })
    },
    getDataFromApi() {
      this.loading = true
      this.selected = [];

      const params = {
        search: this.search,
        page: this.options.page,
      }

      NPService.settlementsList(params)
          .then(response => {
            this.settlements = response.data.data
            this.total = response.data.total
            this.loading = false
          })
    },
  }
}
</script>

<style>
.changed-row {
  background-color: #FFEEEC;
}
</style>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
